<template>
  <Printer></Printer>
</template>

<script>
import Printer from '../components/Printer';
export default {
  components: {
    Printer
  }
};
</script>

<style scoped>
</style>